export default __webpack_public_path__ + "static/media/Market Price Icon.6da847b1.svg";